import { vservice } from '@niknevis/vue-modules'
import { ExportRoute } from '@/modules/common/table-export/routes/export.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class ExportService {
  constructor(
    private readonly route: ExportRoute
  ) {
  }

  checkExportStatus(exportExcel) {
    return HTTP.get(
      this.route.checkExportStatus(exportExcel)
    ).then(result => result.json())
  }

}